import isString from 'lodash-es/isString';

export default {
  state: {
    modalIsOpen: false,
    modalContext: '',
    parent: null,
    editComment: null,
    editCommentHash: '',
    deleteComment: null,
    deleteCommentHash: '',
    showAll: [],
  },

  mutations: {
    setModalIsOpen(state, modalIsOpen = true) {
      state.modalIsOpen = modalIsOpen;
    },

    setModalContext(state, context = '') {
      state.modalContext = context;
    },

    setParent(state, parent = null) {
      state.parent = parent;
    },

    setEditComment(state, editComment = null) {
      state.editComment = editComment;
    },

    setEditCommentHash(state, editCommentHash = '') {
      state.editCommentHash = editCommentHash;
    },

    setDeleteComment(state, deleteComment = null) {
      state.deleteComment = deleteComment;
    },

    setDeleteCommentHash(state, deleteCommentHash = '') {
      state.deleteCommentHash = deleteCommentHash;
    },

    setShowAll(state, parentId) {
      state.showAll.push(parentId);
    },
  },

  actions: {
    toggleModal({ state, commit }, modalContext = '') {
      if (modalContext && isString(modalContext)) {
        commit('setModalContext', modalContext);
      } else {
        commit('setModalContext', 'list');
      }

      commit('setModalIsOpen', !state.modalIsOpen);
    },

    openEditModal(
      { state, commit, dispatch },
      { comment = null, hash = '', parent = null }
    ) {
      commit('setEditComment', comment);
      commit('setEditCommentHash', hash);
      commit('setParent', parent);
      commit('setModalContext', 'edit');
      commit('setModalIsOpen');
    },

    openDeleteModal(
      { state, commit, dispatch },
      { comment = null, hash = '', parent = null }
    ) {
      commit('setDeleteComment', comment);
      commit('setDeleteCommentHash', hash);
      commit('setParent', parent);
      commit('setModalContext', 'delete');
      commit('setModalIsOpen');
    },
  },
  namespaced: true,
};
